export { default } from './fade-in-animation';
